import { withInstall } from '../../utils'

import _Link from './src/link.vue'

export const SdLink = withInstall(_Link)
export default SdLink

export * from './src/link'
